/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListAgentConnectorsQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ListAgentConnectorsQueryParamOrder = ClosedEnum<
  typeof ListAgentConnectorsQueryParamOrder
>;

export type ListAgentConnectorsRequest = {
  /**
   * The agent ID.
   */
  id: string;
  limit?: number | undefined;
  order?: ListAgentConnectorsQueryParamOrder | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListAgentConnectorsQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListAgentConnectorsQueryParamOrder
> = z.nativeEnum(ListAgentConnectorsQueryParamOrder);
/** @internal */
export const ListAgentConnectorsQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListAgentConnectorsQueryParamOrder
> = ListAgentConnectorsQueryParamOrder$inboundSchema;

/** @internal */
export const ListAgentConnectorsRequest$inboundSchema: z.ZodType<
  ListAgentConnectorsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  limit: z.number().int().default(20),
  order: ListAgentConnectorsQueryParamOrder$inboundSchema.default("desc"),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListAgentConnectorsRequest$Outbound = {
  id: string;
  limit: number;
  order: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListAgentConnectorsRequest$outboundSchema: z.ZodType<
  ListAgentConnectorsRequest$Outbound,
  z.ZodTypeDef,
  ListAgentConnectorsRequest
> = z.object({
  id: z.string(),
  limit: z.number().int().default(20),
  order: ListAgentConnectorsQueryParamOrder$outboundSchema.default("desc"),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listAgentConnectorsRequestToJSON(
  listAgentConnectorsRequest: ListAgentConnectorsRequest,
): string {
  return JSON.stringify(
    ListAgentConnectorsRequest$outboundSchema.parse(listAgentConnectorsRequest),
  );
}
export function listAgentConnectorsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentConnectorsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentConnectorsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentConnectorsRequest' from JSON`,
  );
}
